/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const InRevision: core.serialization.ObjectSchema<serializers.InRevision.Raw, Truvity.InRevision> =
    core.serialization.object({
        values: core.serialization.list(core.serialization.number()),
    });

export declare namespace InRevision {
    export interface Raw {
        values: number[];
    }
}
